import axios from "axios";

export default axios.create({
  baseURL: "https://crypto-ranking-data.p.rapidapi.com/",
  headers: {
    "x-rapidapi-host": "crypto-ranking-data.p.rapidapi.com",
    "x-rapidapi-key": process.env.REACT_APP_KEY,
  },
});
